import { z } from 'zod'
import { ScheduleSchema, DocumentSchema } from '../schemas'
import { http } from './http'
import { auth } from './auth'
import { parseWithZod } from '../utils/parse-with-zod'

type ScheduleDocument = z.infer<typeof DocumentSchema>

export type CreateUpdateSchedulePayload = {
  deal_id: number
  item_id: number
  title: string
  attachment_type: 'file' | 'item'
  child_item_id?: number | null
  state?: 'incomplete' | 'complete' | null
  document?: ScheduleDocument | null
}

export type AttachFilePayload = {
  upload_id?: number | null
}

export type AttachChildItemPayload = {
  child_item_id: number
}

const ScheduleResponseSchema = z.object({ schedule: ScheduleSchema })

export const schedules = {
  createSchedule: async (payload: CreateUpdateSchedulePayload, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.post(`${regionHost}/api/schedules`, { schedule: payload }, dealId)
    return parseWithZod(ScheduleResponseSchema, result).schedule
  },

  getSchedule: async (scheduleId: number, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.get(`${regionHost}/api/schedules/${scheduleId}`, undefined, dealId)
    return parseWithZod(ScheduleResponseSchema, result).schedule
  },

  updateSchedule: async (
    scheduleId: number,
    payload: CreateUpdateSchedulePayload,
    dealId: number,
  ) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.put(
      `${regionHost}/api/schedules/${scheduleId}`,
      { schedule: payload },
      dealId,
    )
    return parseWithZod(ScheduleResponseSchema, result).schedule
  },

  deleteSchedule: async (scheduleId: number, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    await http.delete(`${regionHost}/api/schedules/${scheduleId}`, dealId)
  },

  attachFile: async (scheduleId: number, payload: AttachFilePayload, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.post(
      `${regionHost}/api/schedules/${scheduleId}/attach_file`,
      payload,
      dealId,
    )
    return parseWithZod(ScheduleResponseSchema, result).schedule
  },

  attachChildItem: async (scheduleId: number, payload: AttachChildItemPayload, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.post(
      `${regionHost}/api/schedules/${scheduleId}/attach_child_item`,
      payload,
      dealId,
    )
    return parseWithZod(ScheduleResponseSchema, result).schedule
  },
}
